import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { questKeys } from '../quests.keys';
import { listRecommendedQuests } from '../quests.service';
export const useRecommendedQuests = (limit = 10, initialData) => {
    return useInfiniteQuery({
        queryKey: questKeys.recommendedQuests(limit),
        queryFn: ({ pageParam }) => {
            return listRecommendedQuests(pageParam, limit);
        },
        getNextPageParam: lastPage => {
            if (lastPage.hasNextPage) {
                return lastPage.nextPage;
            }
            return undefined;
        },
        retry: 3,
        placeholderData: keepPreviousData,
        initialPageParam: 0,
        initialData: initialData
            ? {
                pages: [initialData],
                pageParams: [0],
            }
            : undefined,
        staleTime: 30000,
    });
};
